import React from 'react';
import { SharedNavbar } from '../components/SharedNavbar';
import { HeroAHA } from '../components/aha/HeroAHA';
import { ProblemSolutionAHA } from '../components/aha/ProblemSolutionAHA';
import { ModulesAHA } from '../components/aha/ModulesAHA';
import { BenefitsAHA } from '../components/aha/BenefitsAHA';
import { AboutMeAHA } from '../components/aha/AboutMeAHA';
import { ForWhomAHA } from '../components/aha/ForWhomAHA';
import { PricingAHA } from '../components/aha/PricingAHA';
import { FAQAHA } from '../components/aha/FAQAHA';
import { FinalCTAAHA } from '../components/aha/FinalCTAAHA';
import { Footer } from '../components/Footer';
export function AHAPage() {
  return <>
      <SharedNavbar data-id="element-818" />
      <main className="flex-grow" data-id="element-819">
        <HeroAHA data-id="element-820" />
        <ProblemSolutionAHA data-id="element-821" />
        <ModulesAHA data-id="element-822" />
        <BenefitsAHA data-id="element-823" />
        <AboutMeAHA data-id="element-824" />
        <ForWhomAHA data-id="element-825" />
        <PricingAHA data-id="element-826" />
        <FAQAHA data-id="element-827" />
        <FinalCTAAHA data-id="element-828" />
      </main>
      <Footer data-id="element-829" />
    </>;
}